<div class="dialog-content">
  <h1 mat-dialog-title>{{ 'common.button.exportToExcel' | translate }}</h1>
  <div *ngIf="data.isReportLimitationExceeded" class="notification">
    <ui-svg-icon [name]="iconNames.AlertWarningFilled" class="notification__icon"></ui-svg-icon>
    <span>
      {{ 'exports.notificationMessage' | translate : { limit: data.reportLimitRows } }}
    </span>
  </div>

  <div mat-dialog-content>
    <form *ngIf="exportDialogForm" [formGroup]="exportDialogForm">
      <mat-form-field>
        <mat-label>{{ 'common.field.reportName' | translate }}*</mat-label>
        <input matInput type="text" formControlName="reportName" />
        <mat-error *ngIf="validationService.hasError(exportDialogForm, 'reportName', 'required')"
          >{{ 'common.validation.error.required' | translate }}
        </mat-error>
        <mat-error *ngIf="validationService.hasError(exportDialogForm, 'reportName', 'mustNotBeBlank')"
          >{{ 'common.validation.error.mustNotBeBlank' | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="hasReportType">
        <mat-label>{{ 'common.field.reportType' | translate }}*</mat-label>
        <mat-select [formControl]="exportDialogForm.controls.reportType">
          <mat-option *ngFor="let type of reportTypeOptions" [value]="type">
            {{ 'export.type.' + type | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox (change)="navigationNeeded = $event.checked">
        {{ 'exports.navigationToExports' | translate }}
      </mat-checkbox>
    </form>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ng-container *ngIf="navigationNeeded; else noNavigation">
      <ui-action-button
        [text]="'common.button.exportToExcelAndNavigate' | translate"
        [type]="buttonType.Primary"
        [testId]="'export-to-excel-popup-button'"
        [disabled]="exportDialogForm.invalid"
        (buttonClick)="confirm(navigationNeeded)"
      ></ui-action-button>
    </ng-container>
    <ng-template #noNavigation>
      <ui-action-button
        [text]="'common.button.exportToExcel' | translate"
        [type]="buttonType.Primary"
        [testId]="'export-to-excel-popup-button'"
        [disabled]="exportDialogForm.invalid"
        (buttonClick)="confirm(navigationNeeded)"
      ></ui-action-button>
    </ng-template>
  </div>
</div>
